import React from "react";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Stack, Typography } from "@mui/material";

export const CorrelationMatrixEmptyState: React.FC = () => {
  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.7;
            }
          }
        `}
      </style>
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          py: "40px",
          flex: 1,
          gap: "16px"
        }}
      >
        <Stack
          sx={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            bgcolor: "#F0F7FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            "&::before": {
              // eslint-disable-next-line quotes
              content: '""',
              position: "absolute",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              border: "2px solid #E3F2FD",
              animation: "pulse 2s ease-in-out infinite"
            }
          }}
        >
          <TrendingUpIcon
            sx={{
              fontSize: "40px",
              color: "#071F35",
              position: "relative",
              zIndex: 1
            }}
          />
        </Stack>
        <Stack sx={{ alignItems: "center", gap: "8px", maxWidth: "280px", textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#071f35",
              lineHeight: 1.4
            }}
          >
            No correlation data yet
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#5d7782",
              lineHeight: 1.5
            }}
          >
            Configure the portfolio settings to see correlation insights
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

